import { createSelector } from "@ngrx/store";
import { AuthState } from "../auth.model";

export const selectAuthFeature = (state: { auth: AuthState }) => state.auth;
export const selectAuthState = createSelector(
  selectAuthFeature,
  (state) => state
);
